export const sexArr = [
	{ val: 0, name: '未知' },
	{ val: 1, name: '男' },
	{ val: 2, name: '女' }
]

export const studentStatus = [
  { val: 0, name: '未入学' },
  { val: 1, name: '就读' },
  { val: 2, name: '毕业' },
  // { val: 3, name: '转校' }
]

export const classStatus = [
  { val: 0, name: '未入学' },
  { val: 1, name: '就读中' },
  { val: 2, name: '毕业' },
]
